import { createAction } from '@reduxjs/toolkit';

import {
  BusylightConnectionStatusPayload,
  BusylightRingPayload,
} from './busylight.types';
import { busylightStatus } from './utils/busylightDeviceManager';

const prefix = 'busylight';

export const busylightActions = {
  getConnectedStatus: createAction(`${prefix}/getConnectedStatus`),
  getConnectedStatusFulfilled: createAction<BusylightConnectionStatusPayload>(
    `${prefix}/getConnectedStatusFulfilled`,
  ),
  getConnectedStatusRejected: createAction(
    `${prefix}/getConnectedStatusRejected`,
  ),
  setStatus: createAction<{ status: keyof typeof busylightStatus }>(
    `${prefix}/setStatus`,
  ),
  setStatusFulfilled: createAction(`${prefix}/setStatusFulfilled`),
  setStatusRejected: createAction(`${prefix}/setStatusRejected`),
  ring: createAction<BusylightRingPayload>(`${prefix}/ring`),
  ringFulfilled: createAction(`${prefix}/ringFulfilled`),
  ringRejected: createAction(`${prefix}/ringRejected`),
  stop: createAction(`${prefix}/stop`),
  stopFulfilled: createAction(`${prefix}/stopFulfilled`),
  stopRejected: createAction(`${prefix}/stopRejected`),
};
